import { configureStore } from "@reduxjs/toolkit";
import {
  persistReducer,
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage/session";
import rootReducer from "../reducers";

// Redux Persist config
const config = {
  key: "root",
  version: 1,
  storage,
  whitelist: ["member", "dashboard", "pageHeader"],
};

const persistedReducer = persistReducer(config, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

// Exported alongside the store (rather than created ad-hoc where needed) so
// callers can `await persistor.flush()` after dispatching a change they need
// durably written to sessionStorage before a hard navigation - see
// DsSessionIdSync in App.tsx, which otherwise races the redirect it triggers.
export const persistor = persistStore(store);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export default store;
